import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Offer } from '@innogy/become-a-customer/shared/interfaces';
import { DefaultComponentModule } from '@innogy/core/modules/components';
import { CSCaptureDirective } from '@legacy/utils-contentsquare';

import {
  CommodityOfferLabels,
  CommodityOfferLayoutType,
} from '../../commodity-offers.model';
import { CommodityOfferCardComponent } from '../../commodity-offer-card/commodity-offer-card.component';
import { CommodityOfferEssentHeaderComponent } from '../../partials/essent/commodity-offer-header/commodity-offer-header.component';
import { CommodityOfferAccordionComponent } from '../../commodity-offer-accordion/commodity-offer-accordion.component';
import { CommodityOfferPriceTagComponent } from '../../partials/shared/commodity-offer-price-tag/commodity-offer-price-tag.component';
import { CommodityOfferViewTariffsComponent } from '../../partials/shared/commodity-offer-view-tariffs/commodity-offer-view-tariffs.component';
import { SMECommodityOfferEssentProductBreakdownComponent } from '../../partials/essent/sme-commodity-product-breakdown/sme-commodity-product-breakdown.component';
import { RoundedCurrencyPipe } from '@innogy/utils-deprecated';

@Component({
  selector: 'essent-sme-acquisition-commodity-offer',
  templateUrl: './essent-sme-acquisition-commodity-offer.component.html',
  standalone: true,
  imports: [
    CommodityOfferCardComponent,
    CommodityOfferEssentHeaderComponent,
    CommodityOfferAccordionComponent,
    DefaultComponentModule,
    CommodityOfferPriceTagComponent,
    CommodityOfferViewTariffsComponent,
    SMECommodityOfferEssentProductBreakdownComponent,
    CSCaptureDirective,
    RoundedCurrencyPipe,
  ],
})
export class EssentSMEAcquisitionCommodityOfferComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() offer?: Offer;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() content?: CommodityOfferLabels;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() variant?: CommodityOfferLayoutType;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() active = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() showMemberGetMember = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() showLoadingState = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() ensureHorizontalAlignment = false;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() enableNewOfferCardTitles? = false;
  @Output() selectOffer = new EventEmitter<void>();
  @Output() openMoreInfo = new EventEmitter<void>();
  @Output() viewTariffs = new EventEmitter<void>();
}
